import { render, staticRenderFns } from "./GalleryContent.vue?vue&type=template&id=621855d0"
import script from "./GalleryContent.vue?vue&type=script&lang=js"
export * from "./GalleryContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports